<template>
  <div class="old-order" v-if="hasOldOrder">
    <div class="tips-detail os-font-14-500">
      {{ tips }}，<span class="go-order" @click="goOrderList">点击查看</span>
    </div>
    <div class="tip-close" @click="closeOderTip"></div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import clientEnv from 'utils/clientEnv'

export default {
  name: 'oldOrder',
  computed: {
    ...mapState('repair', ['repairType', 'hasOldOrder', 'isWeChatApp']),
    tips() {
      return `您有生效中的寄修订单`
    }
  },
  methods: {
    ...mapMutations('repair', ['SET_HAS_OLD_ORDER']),
    ...mapActions('repair', ['jumpToH5']),
    goOrderList() {
      this.jumpToH5(
        `https://www.vivo.com.cn/member/repair/index?show_title=1${clientEnv.isVivoApp || this.isWeChatApp ? '&hideHeader=true' : ''}`
      )
    },
    closeOderTip() {
      this.SET_HAS_OLD_ORDER(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.old-order {
  border-radius: 12px;
  background: #fff;
  padding: 0 16px;
  box-sizing: border-box;
  line-height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 664px;
  margin: 0 16px 12px;

  .vivo-dark-mode & {
    background-color: #1e1e1e;
  }

  @media screen and (min-width: 697px) {
    boxsizing: border-box;
    margin: 0 auto 12px;
  }

  .tips-detail {
    color: #999999;

    .go-order {
      color: #415fff;
    }
  }

  .tip-close {
    display: block;
    width: 20px;
    height: 20px;
    background: url('~@/assets/img/repair/base/wap/close.svg') center center no-repeat;
    background-size: contain;
  }
}
</style>
